module.exports = __webpack_public_path__ + "img/diagnosis-knowledgebase.52266d4b.png";